import { render, staticRenderFns } from "./UserOrganization.vue?vue&type=template&id=aee595b4&scoped=true&"
import script from "./UserOrganization.vue?vue&type=script&lang=js&"
export * from "./UserOrganization.vue?vue&type=script&lang=js&"
import style0 from "./UserOrganization.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserOrganization.vue?vue&type=style&index=1&id=aee595b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee595b4",
  null
  
)

export default component.exports